import { render, staticRenderFns } from "./leave_list.vue?vue&type=template&id=15f20ec2"
import script from "./leave_list.vue?vue&type=script&lang=js"
export * from "./leave_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports